import React from 'react';
import { Button } from '@mui/material';
import { ArrowUpward as UpgradeIcon } from '@mui/icons-material';

/** "Upgrade to Pro" button — app theme, small size; same in Header and Subscription. */
const UpgradeToProButton = ({ onClick, disabled = false, size = 'small', sx = {}, ...rest }) => (
  <Button
    variant="contained"
    color="primary"
    size={size}
    startIcon={<UpgradeIcon />}
    onClick={onClick}
    disabled={disabled}
    sx={{
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 100,
      ...sx,
    }}
    {...rest}
  >
    Upgrade to Pro
  </Button>
);

export default UpgradeToProButton;
